<template>
  <div class="content new-profile">
    <div class="md-layout" @click="selectArea($event)">
       <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
        <h1 v-if="(this.$route.name === 'NewMarketProfile')" class="ml-3 section_header mt-0">Industry Market Profile <try-beta-pill :product="$route.query['data-id'] ? 'market_report' : 'imp'" /></h1>
        <profile-steps />
      </div>
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 mb-4">
        <div class="md-layout md-gutter md-alignment-center-center">
          <div class="searchResultWpr">
            <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50 profile-left-sec">
              <span v-if="(this.$route.name === 'NewMarketProfile')" class="md-title profile-title">Industry Market
                Profile</span>
              <span v-else class="md-title profile-title">Market Report <try-beta-pill product="market_report" :data-id="dataId" /></span>
              <div>
                <p v-if="(this.$route.name === 'NewMarketProfile')" class="description">
                  Our market research covers over 9,000 industry segments and is available for the US, States, Cities,
                  Counties, zip-codes, and customizable market radius. The data highlights local competitors, market
                  volume, market penetration, COVID-impact, demographics, and more.
                </p>

                <p v-else class="description">
                  Combine our market data with your inputs for instant insight into how a company is comparing to
                  competitors in its local area. Results include market share, sales rank, productivity indices, and
                  more.
                </p>
                <ul class="profile_details">
                  <li v-if="industry">
                    <div>
                      <p class="h3-p">{{ industry }}</p>
                        <p class="h6-p">Industry</p>
                    </div>
                  </li>
                  <li v-if="marketArea">
                    <div>
                      <p class="h3-p">{{ marketArea.split('[')[0] }}</p>
                        <p class="h6-p">Market Area</p>
                    </div>
                  </li>
                  <li v-if="mapCenter && mapCenterZip && radius">
                    <div>
                      <p class="h3-p">{{ mapCenter }}; ZIP: {{ mapCenterZip }}; Radius: {{ radius }}</p>
                      <p class="h6-p">Market Area</p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50 profile-right-sec">
              <PulseLoader :loading="loading" :class="{ hide: !loading }" :backgroundWhite="true"></PulseLoader>
              <div class="md-layout">
                <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-100 fin-pro-card no_padding">
                  <profile-card class="toolbar-card">
                    <template slot="header">
                      <div class="toolbar-card-title">
                        <p class="title text-left h5-p">Operations</p>
                      </div>
                    </template>
                    <template slot="content">
                      <div class="info-wrap">{{ operations }}</div>
                    </template>
                  </profile-card>
                </div>
                <div v-if="productPrice && !isAccessible"
                  class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
                  <div class="md-layout-item mt-10">
                    <div class="product-price-label">
                      <h3 class="title text-center">
                        Price:
                        <span class="product-price">${{ productPrice }}</span>
                      </h3>
                    </div>
                  </div>
                </div>
                <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-100">
                  <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
                    <template>
                      <!-- <router-link
                        :to="{
                          name: 'Competitors',
                          params: { id: this.profileId },
                        }"
                      >-->
                      <md-button v-if="isAccessible" @click.native="confirmationModal = true" :disabled="isDisabled || submitting"
                        class="md-info md-block access-button">
                        <span>Access Now</span>
                      </md-button>
                      <md-button v-else @click.native="access" :disabled="isDisabled || submitting"
                        class="md-info md-block access-button">

                        <span>{{ submitting ? "Processing..." : "Add To Cart" }}</span>
                      </md-button>
                      <!-- </router-link> -->
                    </template>
                    <div class="alert md-layout-item" v-if="notAvailable">
                      <span class="closebtn" @click="closeAlert">&times;</span>
                      Sorry, we do not have enough data available for this
                      selection. Please try again.
                    </div>
                    <!-- <pulse-loader :color="'blue'" :loading="loading">
                    </pulse-loader>-->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

     

    </div>
    <div class="prospect_content">
      <modal v-if="confirmationModal" @close="confirmationModal = false">
        <template slot="header">
          <button type="button" class="close_btn" @click="confirmationModal = false">
            <md-icon>clear</md-icon>
          </button>
        </template>
        <template slot="body">
          <div class="field_wpr">
            <h4 class="modal-title">
              Please confirm access to this product with the selected parameters.
              Click Review to review the parameters or Access Now to access this product.
            </h4>
            <div class="ml-4 md-layout">
              <md-button @click="confirmationModal = false" :disabled="submitting"
                class="md-layout-item md-medium-size-40 md-xsmall-size-40 md-size-40">Review</md-button>
              <md-button @click="access" :disabled="submitting" class="md-layout-item md-medium-size-40 md-xsmall-size-40 md-size-40">{{ submitting ? "Processing..." : "Access Now" }}</md-button>
            </div>
          </div>
        </template>
      </modal>
      <modal v-if="modalRadius" @close="closeModalRadius" class="demographics-modal">
        <template slot="header">
          <button type="button" class="close_btn" @click="closeModalRadius">
            <md-icon>clear</md-icon>
          </button>
        </template>
        <template slot="body">
          <form action class="form_grp">
            <label class="md-layout-item md-size-25 md-form-label">USE THIS TO SELECT THE MAP CENTER-POINT FOR VIEWING
              THE 250 CLOSEST INDUSTRY OPERATIONS</label>
            <div class="md-layout spacing">
              <div class="md-layout-item">
                <md-field class="md-invalid align-div-components">
                  <label>.</label>
                  <md-input v-model="mapCenter" placeholder="Address" />
                </md-field>
              </div>

            </div>
            <div class="md-layout spacing">

              <div class="md-layout-item">
                <md-field class="md-invalid align-div-components">
                  <label>.</label>
                  <md-input v-model="mapCenterZip" placeholder="ZIP" />
                </md-field>
              </div>
            </div>
          </form>
          <form action class="form_grp">
            <label class="md-layout-item md-size-25 md-form-label">RADIUS</label>
            <div class="md-layout spacing">
              <div class="md-layout-item">
                <md-field class="md-invalid align-div-components">
                  <label>.</label>
                  <md-input v-model="radius" placeholder="Up to xxx miles (decimals ok) maximum 100 mile radius" />
                </md-field>
              </div>
            </div>
          </form>
          <div class="field_wpr">
            <div class="ml-7 md-layout">
              <md-button @click="setToRadiusParametersNull"
                class="color-black md-layout-item md-medium-size-30 md-xsmall-size-30 md-size-30">Cancel</md-button>
              <md-button @click="setRadius" class="color-black md-layout-item md-medium-size-30 md-xsmall-size-30 md-size-30">Add
              </md-button>
            </div>
          </div>
        </template>
      </modal>
    </div>
  </div>
</template>

<script>
import { Modal, ProfileCard, PulseLoader } from '@/components';
import ProfileSteps from './_market_partials/ProfileSteps.vue';
import TryBetaPill from './SelectorBeta/TryBetaPill.vue';
import { trackSelectorViewed, trackSelectorCompleted } from './SelectorBeta/analytics';
import axios from 'axios';
import { mapState } from 'vuex';

function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export default {
  name: 'new-market-profile',
  components: {
    ProfileCard,
    ProfileSteps,
    TryBetaPill,
    PulseLoader,
    Modal,
  },
  data() {
    return {
      confirmationModal: false,
      isDisabled: true,
      submitting: false,
      operations: '',
      loading: false,
      myData: null,
      years: this.marketData,
      isAccessible: true,
      productPrice: null,
      mapCenter: null,
      mapCenterZip: null,
      radius: null,
      notAvailable: false,
    };
  },
  props: ['dataId', 'isCSV', 'file', 'marketData'],
  methods: {
    setRadius() {
      if (this.industry) {
        this.$store.commit('M_SET_MARKET_AREA', null);
        this.checkAvailability();
      }

      this.closeModalRadius();
    },
    closeAlert: function () {
      this.notAvailable = false;
    },
    setToRadiusParametersNull() {
      this.mapCenter = null;
      this.mapCenterZip = null;
      this.radius = null;
      this.$store.commit('M_SET_SEARCH_MARKET_RADIUS', null);
      this.$store.commit('M_SET_SEARCH_MARKET_CENTER', null);
      this.$store.commit('M_SET_SEARCH_MARKET_CENTER_ZIP', null);

      this.closeModalRadius();
    },
    closeModalRadius() {
      this.$store.commit("M_SET_MODAL_MARKET_RADIUS", false);
    },
    selectArea: function (e) {
      let parentDiv = document.querySelectorAll('.custom-step-pro');
      let deactiveClass = document.querySelectorAll('.step-progress__step');
      let favoriteDropdown = document.querySelectorAll('.favourite_list');
      deactiveClass.forEach(function (el) {
        el.classList.remove('open');
      });
      favoriteDropdown.forEach(function (el) {
        el.classList.remove('open');
      });
      parentDiv.forEach(function (el) {
        el.addEventListener('click', function (e) {
          e.stopPropagation();
        });
      });
    },
    getData: function (name) {
      if (name) {
        return name.split('[')[1].split(']')[0];
      }

      return name;
    },
    access: async function () {
      if (this.submitting) return;
      this.submitting = true;
      try {
      if (this.dataId) {
        await this.addInputsForReport(this.profileId);
      } else {
        let params = {
          product_id: this.profileId,
        };


        let queueUserID = this.$store.getters["user/user_id"];
        if(queueUserID == 372679 || true) {
          localStorage.setItem("queueUserID", queueUserID);
          let currentSession = localStorage.getItem("vue-authenticate.vueauth_access_token");
          await axios
            .get(process.env.VUE_APP_API_BASE_URL + '/queue/load/' + this.profileId, {
              params: {session_id: currentSession},
            })
            .then((res) => {}
          );
        } else {
          localStorage.setItem("queueUserID", null);
        }

        await this.$store.dispatch('cart/accessProduct', params).then((res) => {

          // First things first, let's start the async load:


          if (res.cart) {
            this.$router.push({
              name: 'Cart',
              params: { id: this.profileId },
            });
          }

          if (res.access || (res.error && res.errorCode === 'product_already_accessed')) {
            this.loaded = true;
            trackSelectorCompleted(this.$route.query['data-id'] ? 'market_report' : 'imp', 'classic');
            this.$router.push({
              name: 'MarketAboutTheData',
              params: { id: this.profileId },
            });
          }
        });
      }
      } finally {
        this.submitting = false;
      }
    },
    checkAccessByType: async function () {
      if (this.$route.name === 'NewMarketProfile') {
        if (this.subscriptions.includes('usmr_p') || this.subscriptions.includes('lmr_p'))
          this.isAccessible = true;
        else
          this.isAccessible = false;
      } else {
        if (this.subscriptions.includes('usmr_r') || this.subscriptions.includes('lmr_r'))
          this.isAccessible = true;
        else
          this.isAccessible = false;
      }
    },
    checkAccess: async function () {
      let params = {
        product_id: this.profileId,
      };

      await this.$store
        .dispatch('cart/checkProductAccess', params)
        .then((res) => {
          const { access, ready } = res;
          this.isAccessible = access;
          this.productPrice = res.price;

          if (ready) {
            this.isDisabled = false;
          } else {
            this.isDisabled = true;
            this.notAvailable = true;
          }
          this.loading = false;
        });
    },
    addInputsForReport: async function (profileId) {
      this.loaded = false;
      let currentSession = localStorage.getItem(
        'vue-authenticate.vueauth_access_token'
      );

      let data = {
        year_0_check: true,
        accounts_payable_business_revenue_check: true,
        ebitda_business_revenue_check: true,
        current_ratio_check: true,
        return_on_assets_check: true,
        quick_ratio_check: true,
        return_on_net_worth_check: true,
        days_payable_check: true,
        return_on_business_revenue_check: true,
        current_liabilities_inventory_check: true,
        discretionary_owner_earnings_check: true,
        net_working_capital_check: true,
        return_on_assets_after_tax_check: true,
        cosPayables_check: true,
        return_on_net_worth_after_tax_check: true,
        cosInventory_check: true,
        return_on_business_revenue_after_tax_check: true,
        profit_employee_check: true,
        owner_earnings_employee_check: true,
        assets_business_revenue_check: true,
        interest_coverage_check: true,
        days_inventory_check: true,
        current_liabilities_net_worth_check: true,
        days_receivables_check: true,
        long_term_liabilities_net_worth_check: true,
        current_asset_turnover_check: true,
        loans_notes_payable_net_worth_check: true,
        fixed_asset_turnover_check: true,
        zscore_check: true,
        gross_margin_business_revenue_check: true,
        total_liabilities_net_worth_check: true,
        sales_per_employee_check: true,
        fixedAssetsNetWorth_check: true,
        invTurnover_check: true,
        arTurnover_check: true,
        totalAssetTurnover_check: true,
        workingCapitalTurnover_check: true,
        daysWorkingCapital_check: true,
        cashTurnover_check: true,
        efficiency_index_check: true,
        year_1_check: true,
        year_3_check: true,
        year_4_check: true,
        year_2_check: true,
        pl_balance_percent_check: true,
        pl_balance_dollar_check: true,
        source_uses_check: true,
        ratio_scores_check: true,
        summary_scores_check: true,
      };
      let i = 0;

      this.years.forEach((year) => {

        data['sales_' + i] = year.businessRevenue;
        data['rent_' + i] = year.rent;
        data['employment_' + i] = year.employment;
        data['avg_wage_' + i] = year.averageAnnualWage;

        i = i + 1;
      });
      let params = {
        type: 'imr',
        action: 'save',
        session_id: currentSession,
        profile_id: this.profileId,
        report_id: this.profileId,
        delayedSave: true,
        data: data,
      };

      await this.$store.dispatch('user/saveReport', params).then((res) => {
        this.$store.dispatch('alerts/success', 'Inputs applied.');

        params = {
          product_id: this.profileId,
        };

        this.$store.dispatch('cart/accessProduct', params).then((res) => {
          if (res.cart) {
            this.$router.push({
              name: 'Cart',
              params: { id: this.profileId },
            });
          }

          if (res.access || (res.error && res.errorCode === 'product_already_accessed')) {
            this.loaded = true;
            if (this.dataId) {
              this.$router.push({
                path: `/market-report/${this.profileId}/market-rep-about-data`,
              });
            } else {
              this.$router.push({
                name: 'MRAboutTheData',
                params: { id: this.profileId },
              });
            }
          }
        });
      });
    },
    clearAll: async function () {
      this.$store.commit('M_SET_PROFILE_ID', null);
      this.$store.commit('SET_PROFILE_ID', null);
    },
    checkAvailability: async function () {
      // Each selection change starts a fresh availability check. Bump the generation so
      // any older in-flight poll loop below stops instead of firing more queue/check
      // requests for a job that has already completed and been consumed (that trailing
      // request 500s). beforeDestroy bumps it too, so leaving the page stops polling.
      this.availabilityPollGen = (this.availabilityPollGen || 0) + 1;
      const pollGen = this.availabilityPollGen;
      const pollStopped = () => this.availabilityPollGen !== pollGen;

      let currentSession = localStorage.getItem(
        'vue-authenticate.vueauth_access_token'
      );

      if (this.industry != null && (this.marketArea != null || (this.mapCenter != null && this.mapCenterZip != null && this.radius != null))) {
        this.operations = '';
        this.isDisabled = true;
        this.loading = true;

        let resZips = '0';
        let resArea = 0;
        let resMap_center = '0';
        let resMap_center_zip = '0';
        let resRadius = '0';
        let route = null;
        if (this.$route.name === 'NewMarketProfile')
          route = '/user/search_profiles/imr';
        else
          route = '/user/search_reports/imr';

       
        await axios
          .post(
            process.env.VUE_APP_API_BASE_URL + route,
            {},
            {
              params: {
                session_id: currentSession,
                profile_id: this.profileId ? this.profileId : '0',
                type: 'imr',
                industry: this.getData(this.industry) ?? null,
                map_center: !this.marketArea ? this.mapCenter : null,
                map_center_zip: !this.marketArea ? this.mapCenterZip : null,
                radius: !this.marketArea ? this.radius : null,
                zips: !this.marketArea ? this.mapCenterZip : null,
              },
            }
          )
          .then((res) => {
            if (res.hasOwnProperty('data') && res.data.error) {
              this.$store.commit('SET_ERROR_BIT', true);
              this.$store.commit(
                'SET_ERROR_INFO',
                '<br>' +
                'Server responded with error = True <br> errorCode: ' +
                res.data.errorCode +
                `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/search_profiles/imr" <br>`
              );
              throw new Error(
                '<br>' +
                'Server responded with error = True <br> errorCode: ' +
                res.data.errorCode
              );
            }
            const {
              id,
              area,
              zips,
              map_center,
              map_center_zip,
              radius,
            } = res.data;
            this.$store.commit('M_SET_PROFILE_ID', id);
            resZips = zips;
            resArea = area;
            resMap_center = map_center;
            resMap_center_zip = map_center_zip;
            resRadius = radius;
          
          })
          .catch((err) => {
            // Free-account daily cap: the global dialog explains it. Stop the spinner and keep
            // Access disabled, then rethrow so the check ends exactly as before.
            if (err && err.dailyLimit) {
              this.loading = false;
              this.isDisabled = true;
            }
            throw err;
          });
        
        // ------
        let queueString = this.getData(this.industry);
        queueString += '/';
        queueString += this.getData(this.marketArea);
        queueString += '/0/';
        queueString += this.getData(this.marketArea) == 'zips' ? this.marketArea.replace('+', '').split('[')[0] : '0';
        queueString += '/';
        queueString += !this.marketArea ? resMap_center : '0';
        queueString += '/';
        queueString += !this.marketArea ? resMap_center_zip : '0';
        queueString += '/';
        queueString += !this.marketArea ? resRadius : '0';
        // -------
        let totalTime = 0;
        let interval = 10000; // 10s timestep to avoid spamming the endpoint.
        let statusData = null;
        let keepRunning = true;

        await axios
            .get(process.env.VUE_APP_API_BASE_URL
              + '/queue/load/'+currentSession+'/imp_avail/'
              + queueString
              , {
              params: {session_id: currentSession},
            })
            .then((res) => {
              // If the job already finished (cached/synchronous completion), the load
              // response is the final status: skip polling entirely, since a queue/check
              // for an already-consumed job is a guaranteed 500.
              if (res && res.data && res.data.finished == true && res.data.data != null) {
                statusData = res;
              }
            }
          );

          while((statusData == null || statusData.data.finished == false) && keepRunning) {
            if(pollStopped()) { return; } // superseded by a newer check, or page left
            if(totalTime >= 600000) { throw new Error("Queue load timed out!"); break; } // 600s timeout (10min)
            if(statusData) { await sleep(interval); }
            if(pollStopped()) { return; } // re-check after sleeping, before firing another queue/check
            totalTime += interval;
            await axios.get(process.env.VUE_APP_API_BASE_URL
                + '/queue/check/'+currentSession+'/imp_avail/'
                + queueString
                , {
                params: {session_id: currentSession},
              })
              .then((res) => {
                statusData = res;
              }
            );
            if(statusData.data.data != null) { break; }
          }
          if(pollStopped()) { return; } // stale result: a newer check owns the UI now
          
          if(statusData.error) {
            //console.log("ERROR!!!");
            throw new Error(statusData.data.errorCode);
          }
          
          let res = null;
          const maxParseAttemptsImp = 3;
          for (let attempt = 1; attempt <= maxParseAttemptsImp; attempt++) {
            try {
              res = JSON.parse(JSON.parse(statusData.data.data));
              break;
            } catch (e) {
              // A response can arrive truncated if it was in flight when the
              // backend task got cycled out mid-stream. The job itself already
              // finished server-side, so re-checking should return the same
              // completed data intact; only give up after repeated truncation.
              if (attempt === maxParseAttemptsImp) { res = null; break; }
              if (pollStopped()) { return; }
              await sleep(3000);
              await axios.get(process.env.VUE_APP_API_BASE_URL
                  + '/queue/check/'+currentSession+'/imp_avail/'
                  + queueString
                  , { params: {session_id: currentSession} })
                .then((r) => { statusData = r; });
            }
          }
          try {
            if (res == null) {
              this.operations = '';
              this.isDisabled = true;
              this.loading = false;
              this.notAvailable = true;
            } else if ((res.hasOwnProperty("data") && res.data.error) || (res.hasOwnProperty("error") && res.error)) {
                let errorMessage = null;

                if(res.hasOwnProperty("data")) {
                  errorMessage = res.data.errorCode;
                } else {
                  errorMessage = res.errorCode;
                }

                this.$store.commit("SET_ERROR_BIT", true);
                this.$store.commit(
                  "SET_ERROR_INFO",
                  "<br>" +
                    "Server responded with error = True <br> errorCode: " +
                    errorMessage +
                    `<br> ${process.env.VUE_APP_API_BASE_URL} +'/info/IF_legacy_available' <br>`
                );
                throw new Error(
                  "<br>" +
                    "Server responded with error = True <br> errorCode: " +
                    errorMessage
                );
              } else if (res.data != 0) {
              this.operations = res.data[0];
              this.checkAccess();
            } else {
              this.operations = '';
              this.isDisabled = true;
              this.loading = false;
              this.notAvailable = true;
            }
          } catch (e) {
            console.error(e); // error in the above string (in this case, yes)!
            console.log(res);
          }
          // -------

        /*await axios
          .get(process.env.VUE_APP_API_BASE_URL + '/info/IMR_available', {
            params: {
              industry: this.getData(this.industry),
              area: this.getData(this.marketArea),
              zips: this.getData(this.marketArea) == 'zips' ? this.marketArea.replace('+', '').split('[')[0] : null,
              map_center: !this.marketArea ? resMap_center : null,
              map_center_zip: !this.marketArea ? resMap_center_zip : null,
              radius: !this.marketArea ? resRadius : null,
            },
          })
          .then((res) => {
            if (res.hasOwnProperty('data') && res.data.error) {
              this.$store.commit('SET_ERROR_BIT', true);
              this.$store.commit(
                'SET_ERROR_INFO',
                '<br>' +
                'Server responded with error = True <br> errorCode: ' +
                res.data.errorCode +
                `<br> ${process.env.VUE_APP_API_BASE_URL} + "/info/IMR_available" <br>`
              );
              throw new Error(
                '<br>' +
                'Server responded with error = True <br> errorCode: ' +
                res.data.errorCode
              );
            }
            const { data } = res.data;
            if (data != 0) {
              this.operations = data[0];
              this.checkAccess();
            } else {
              this.operations = '';
              this.isDisabled = true;
              this.loading = false;
               this.notAvailable = true;
            }
          });*/
          // -----
      } else {
        this.isDisabled = true;
        this.operations = '';
      }
    },

  },
  computed: {
    ...mapState({
      auth_user: (state) => state.user,
      defaultScreen: (state) => state?.user?.user?.preferences?.defaultScreen,
      subscriptions: (state) => state.user.user_subscriptions ?? null,
    }),
    industry() {
      return this.$store.getters.mIndustry;
    },
    marketArea() {
      return this.$store.getters.mMarketArea;
    },
    profileId() {
      return this.$store.getters.mProfileId;
    },
    modalRadius() {
      return this.$store.getters.mModalMarketRadius;
    },
    marketAreaCenterZip() {
      return this.$store.getters.mSearchMarketCenterZip;
    },
    marketAreaCenter() {
      return this.$store.getters.mSearchMarketCenter;
    },
    marketAreaRadius() {
      return this.$store.getters.mSearchMarketRadius;
    }
  },
  watch: {
    industry(newValue, oldValue) {
      this.notAvailable = false;
      this.checkAvailability();
    },
    marketArea(newValue, oldValue) {
      this.notAvailable = false;
      if (newValue != null) {
        this.mapCenter = null;
        this.mapCenterZip = null;
        this.radius = null;
      }

     
      this.checkAvailability();
    },
    mapCenter() {
      this.notAvailable = false;
      this.$store.commit('M_SET_SEARCH_MARKET_CENTER', this.mapCenter);
    },
    mapCenterZip() {
      this.notAvailable = false;
      this.$store.commit('M_SET_SEARCH_MARKET_CENTER_ZIP', this.mapCenterZip);
    },
    radius() {
      this.notAvailable = false;
      this.$store.commit('M_SET_SEARCH_MARKET_RADIUS', this.radius);
    },
    subscriptions() {
      if (this.subscriptions && this.subscriptions.length > 0)
        this.checkAccessByType()
    }
  },
  async created() {

    await this.clearAll();
  },
  mounted() {
    if (this.$route.name === 'NewMarketProfile')
      trackSelectorViewed(this.$route.query['data-id'] ? 'market_report' : 'imp', 'classic');
  },
  beforeDestroy() {
    // Stop any in-flight availability poll loop (see checkAvailability) so no
    // trailing queue/check fires after the user has left the page.
    this.availabilityPollGen = (this.availabilityPollGen || 0) + 1;
  },
};
</script>
<style lang="scss">
.new-profile {
  margin-top: 20px;
}

.profile-left-sec {
  padding: 10px;
  padding-left: 30px !important;
}

@media only screen and (max-width: 600px) {
  .fin-pro-card {
    margin-bottom: 10px;
  }

  .profile-left-sec {
    margin-bottom: 10px;
  }

  .fin-tab-list {
    margin-top: 350px;
  }

  #finantialProfileTabs .md-tabs-navigation {
    padding-left: 15px;
  }
}

@media screen and (max-width: 1280px) and (min-width: 600px) {
  .fin-tab-list {
    margin-top: 150px;
  }
}

.product-price {
  color: #3b7ef1;
  font-weight: 500;
}

.product-price-label {
  margin-top: 30px;
}

.product-price-label .title {
  margin-bottom: 0px;
}
</style>
